/*
These functions make sure WordPress
and Foundation play nice together.
*/

AOS.init();

jQuery(document).ready(function($) {
  
  var homeSwiper = new Swiper('#home-hero .swiper-container', {
    init: false,
    loop: true,
    effect: 'fade',
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  })
  homeSwiper.on('transitionStart', function() {
    var caption = $('#home-hero .swiper-container .swiper-slide-active').attr('data-caption');
    $('#home-swiper-caption').fadeOut().html(caption);
  });
  homeSwiper.on('transitionEnd', function() {
    $('#home-swiper-caption').fadeIn();
  });
  if($('#home-hero .swiper-container').length) {
    homeSwiper.init();
  }

  jQuery('.woocommerce-cart .quantity .qty').attr("disabled", true);

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
});